// utils/formatTanggal.js
import dayjs from "dayjs";
import "dayjs/locale/id";
dayjs.locale("en");

export function formatDate(tanggal) {
  const date = dayjs(tanggal);
  return date.isValid() ? date.format("D MMMM YYYY") : "- / -";
}

export function formatDateTime(tanggal) {
  const date = dayjs(tanggal);
  return date.isValid()
    ? date.format("D MMMM YYYY HH:mm:ss") + " WIB"
    : "- / -";
}

export function formatDecimal(number) {
  number = typeof number === "string" ? parseFloat(number) : number;

  if (typeof number !== "number" || isNaN(number)) return "";

  const [int, dec] = number.toString().split(".");

  const formattedInt = int.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  if (dec && parseInt(dec) !== 0) {
    return `${formattedInt},${dec.replace(/0+$/, "")}`;
  }

  return formattedInt;
}

export function formatRupiah(value, withPrefix = true) {
  if (value == null || isNaN(value) || !value) return withPrefix ? "Rp 0" : "0";

  const strValue = value.toString().split(".")[0];
  const formatted = strValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  return withPrefix ? `Rp ${formatted}` : formatted;
}

export function parseRupiah(str) {
  if (!str) return 0;

  return (
    parseFloat(
      str
        .toString()
        .replace(/[^0-9,]/g, "")
        .replace(/\./g, ""),
    ) || 0
  );
}

export function formatDatePeriode(programs) {
  if (!programs || !Array.isArray(programs) || programs.length === 0) {
    return "- / -";
  }

  // Extract unique valid dates
  const uniqueDateMap = {};
  programs.forEach((p) => {
    const d = p.date || p.start || p.end || (typeof p === "string" ? p : null);
    if (d) {
      const parsed = dayjs(d);
      if (parsed.isValid()) {
        const key = parsed.format("YYYY-MM-DD");
        uniqueDateMap[key] = parsed;
      }
    }
  });

  const dates = Object.values(uniqueDateMap).sort(
    (a, b) => a.valueOf() - b.valueOf(),
  );

  if (dates.length === 0) return "- / -";
  if (dates.length === 1) return dates[0].format("D MMMM YYYY");

  const formatDays = (days) => {
    if (days.length === 1) return days[0].toString();
    const ranges = [];
    let start = days[0];
    let end = days[0];
    for (let i = 1; i < days.length; i++) {
      if (days[i] === end + 1) {
        end = days[i];
      } else {
        ranges.push(start === end ? start.toString() : `${start} - ${end}`);
        start = days[i];
        end = days[i];
      }
    }
    ranges.push(start === end ? start.toString() : `${start} - ${end}`);

    if (ranges.length === 1) return ranges[0];
    const last = ranges.pop();
    return ranges.join(", ") + " & " + last;
  };

  const groupsByMonth = [];
  let currentMonthGroup = null;
  dates.forEach((d) => {
    const monthYear = d.format("MMMM YYYY");
    const month = d.month();
    const year = d.year();
    if (!currentMonthGroup || currentMonthGroup.monthYear !== monthYear) {
      currentMonthGroup = { monthYear, month, year, days: [] };
      groupsByMonth.push(currentMonthGroup);
    }
    if (!currentMonthGroup.days.includes(d.date())) {
      currentMonthGroup.days.push(d.date());
    }
  });

  const isSameYear = groupsByMonth.every(
    (g) => g.year === groupsByMonth[0].year,
  );

  const formattedGroups = groupsByMonth.map((g, index) => {
    const daysStr = formatDays(g.days);
    if (isSameYear && index < groupsByMonth.length - 1) {
      const monthName = dayjs().month(g.month).format("MMMM");
      return `${daysStr} ${monthName}`;
    }
    return `${daysStr} ${g.monthYear}`;
  });

  if (formattedGroups.length === 1) return formattedGroups[0];
  const lastGroup = formattedGroups.pop();
  return formattedGroups.join(", ") + " & " + lastGroup;
}
